<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('pedidos.pedidos')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <!-- rList Table CARD-->
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="Pedido"
        :tableCode="'PEDIDO'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :shownFields="['estado.estado', 'contratacion.codEmpleado', 'cliente.empleadoVentas', 'cliente.responsable', 'lineas.inspectores.username', 'lineas.camposUsuario.cpEj', 'lineas.comision', 'lineas.proveedor','lineas.item', 'lineas.administrador', 'lineas.instalador', 'lineas.mantenedor', 'lineas.asociacion','lineas.numero', 'bcId']"
        :massiveActions="true"
        :showProgress="true"
        :funcShowCheck="showCheckInList"
        :controlsWidth="100"
        :searchOnInit="searchOnInit"
        :primary="['id']"
        :paginationFilterSort="true"
      >
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="$t('common.ver')" icon-f7="eye" color="green" :href="`/pedidos/view/${item.id}/`"></f7-link>
          <f7-link v-if="!item.estado || (item.estado.estado != 'FACTURADO' && item.estado.estado != 'CANCELADO' && item.estado.estado != 'CERRADO')" v-tooltip="$t('common.editar')" icon-f7="square_pencil" color="blue" :href="`/pedidos/edit/${item.id}/`"></f7-link>
          <f7-link v-if="item.bcId" v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.verEnBC')" icon-f7="link" color="orange" @click="verEnBC(item.bcId)"></f7-link>
          <f7-link v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.enviarBC')" icon-f7="arrow_up_circle" color="purple" @click="enviarBC(item.id)"></f7-link>
        </template>
        <template v-slot:massiveActions="{}">
          <f7-button
            fill
            icon-f7="envelope"
            text="Enviar email"
            class="display-flex"
            color="purple"
            @click="abrirEnvioEmail()"
          ></f7-button>
        </template>
      </r-dynamic-list>
    </f7-page-content>
    <envio-mail
      v-show="true"
      ref="enviarEmail"
      :opened="enviarEmail"
      :selected="selectedItems" 
      :entityConfig="emailConfigs.pedido"
      @email-enviado="onEmailEnviado"
    ></envio-mail>

  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import EnvioMail from "./../../components/envio-mail.vue";
import {emailConfigs} from "./../../js/email-configs.js";
import Pedido from "./../../js/db/Pedido.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: {
    rDynamicList,
    EnvioMail
  },
  data() {
    return {
      Pedido,
      enviarEmail: false,
      selectedItems: [],
      emailConfigs
    };
  },
  props: {
    searchOnInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    onEmailEnviado() {
      console.log('🔒 Email enviado evento recibido');
      this.enviarEmail = false;
      this.selectedItems = [];
    },

    abrirEnvioEmail() {
      const self = this;
      // Preparar items seleccionados usando el método existente filasSeleccionadas
      self.selectedItems = self.filasSeleccionadas();
      self.enviarEmail = true;
    },

    filasSeleccionadas: function() {
      let pedidos = [...Object.values(this.$refs.rlist.selected)]
      // desagregamos  las líneas para tener una sola línea dentro de cada pedido
      let lineasPedido = [];
      pedidos.forEach(p => {
        p.lineas.forEach(l => {
          let lineaDesagregada = {id: p.id};
          lineaDesagregada.numerosLinea = [l.numero];
          lineasPedido.push(lineaDesagregada);
        });
      });
      
      return lineasPedido;
    },
    showCheckInList: function(item) {
      // return item.estado && item.estado.estado && item.estado.estado == "CREADO";
      return item.estado && item.estado.estado && (item.estado.estado !== "CANCELADO" && item.estado.estado !== "CERRADO");
    },
    verEnBC: function(bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para este pedido.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir el pedido en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=42';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    enviarBC: function(idPedido) {
      var self = this;
      var app = self.$f7;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Pedido.enviarBC({ itemId: idPedido }).then(function (res) {
        espera.cerrar();
        app.toast
          .create({
            text: self.$t("pedidos.envio_bc_ok"),
            position: "center",
            closeTimeout: 2000,
            icon: '<i class="f7-icons">checkmark_alt</i>'
          })
          .open();
        self.$refs.rlist.reload();
      }).catch(function (error) {
        espera.cerrar();
        app.dialog.alert(error.message);
      });
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    /*app.dataTable.create({
      el: self.$refs.datatable
    });*/
  }
};
</script>